<template>
	<span @click="endCountFn()">{{countString}}</span>
</template>
<script>
export default {
	name: 'chronograph',
	data() {
		return {
			isStart: false,
			globalTimer: null,
			countString: '00:00', //用来显示时间
			day: 0,
			hour: 0,
			minute: 0,
			second: 0,
			millisecond: 0,
			countVal: 0, //获取初始值
			pauseTime: 0
		}
	},
	props: {
		isStarts: {
			type: Boolean,
			default: false
		},
		countVals: {
			type: Number,
			default: 0
		}
	},
	watch: {
		// isStart: function(val) {
		// 	debugger
		// 	if (val) {
		// 		this.startCountFn()
		// 	}
		// },
		isStarts: {
			deep: true,
			immediate: true,
			handler: function(val) {
				if (val) {
					this.isStart = val
					this.day = 0
					this.hour = 0
					this.minute = 0
					this.second = 0
					this.millisecond = 0
					this.pauseTime = 0
					this.startCountFn()
				}
			}
		},
		countVals: {
			deep: true,
			handler: function(val) {
				// if (val > 0 && this.isStart) {
				// 	this.startCountFn()
				// } else {
				// 	this.endCountFn()
				// }
				if (this.isStarts) {
					this.day = 0
					this.hour = 0
					this.minute = 0
					this.second = 0
					this.millisecond = 0
					this.pauseTime = 0
					this.countVal = val
					this.startCountFn()
				}
			}
		}
	},
	mounted: function() {},
	created: function() {
		if (this.isStarts) {
			this.startCountFn()
		}
	},
	methods: {
		counterFn: function(counterTime) {
			var vm = this
			var nowDate = new Date().getTime()
			if (vm.pauseTime == 0) {
				var num = nowDate - counterTime //计算时间毫秒差
			} else {
				vm.pauseTime = vm.pauseTime + 10
				var num = vm.pauseTime - counterTime //计算时间毫秒差
			}
			var leave1 = num % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
			var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
			var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
			vm.day = Math.floor(num / (24 * 3600 * 1000)) //计算相差天数
			vm.hour = Math.floor(leave1 / (3600 * 1000)) //计算相差小时
			vm.minute = Math.floor(leave2 / (60 * 1000)) //计算相差分钟
			vm.second = Math.round(leave3 / 1000) //计算相差秒
			if (vm.day > 0) {
				let day = ''
				let hour = ''
				let minute = ''
				let second = ''
				if (vm.day < 10) {
					day = `0${vm.day}`
				} else {
					day = vm.day
				}
				if (vm.hour < 10) {
					hour = `0${vm.hour}`
				} else {
					hour = vm.hour
				}
				if (vm.minute < 10) {
					minute = `0${vm.minute}`
				} else {
					minute = vm.minute
				}
				if (vm.second < 10) {
					second = `0${vm.second}`
				} else {
					second = `${vm.second}`
				}
				vm.countString = `${day}:${hour}:${minute}:${second}`
			} else if (vm.hour > 0) {
				let hour = ''
				let minute = ''
				let second = ''
				if (vm.hour < 10) {
					hour = `0${vm.hour}`
				} else {
					hour = vm.hour
				}
				if (vm.minute < 10) {
					minute = `0${vm.minute}`
				} else {
					minute = vm.minute
				}
				if (vm.second < 10) {
					second = `0${vm.second}`
				} else {
					second = vm.second
				}
				vm.countString = `${hour}: ${minute}: ${second}`
			} else if (vm.minute > 0) {
				let minute = ''
				let second = ''
				if (vm.minute < 10) {
					minute = `0${vm.minute}`
				} else {
					minute = `${vm.minute}`
				}
				if (vm.second < 10) {
					second = `0${vm.second}`
				} else {
					second = `${vm.second}`
				}
				vm.countString = `${minute}: ${second}`
			} else {
				if (vm.second < 10) {
					vm.countString = `00:0${vm.second}`
				} else {
					vm.countString = `00:${vm.second}`
				}
			}
		},
		startCountFn: function() {
			var vm = this
			if (vm.isStart) {
				vm.countVal = vm.countVal ? vm.countVal : new Date().getTime()
				var timer = setInterval(function() {
					vm.counterFn(vm.countVal)
				}, 10)
				vm.$emit('cuurentTime', vm.countVal)
				vm.globalTimer = timer
			}
		},
		endCountFn: function() {
			let vm = this
			if (vm.isStart) {
				window.clearInterval(vm.globalTimer)
				vm.globalTimer = null
				vm.isStart = false
				vm.pauseTime = new Date().getTime()
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/customer/customers/chronograph.vue